import React from 'react'
import PropTypes from 'prop-types'

import { Redirect } from 'react-router-dom'

import { Permitted } from 'components/Permissions'
import { useAuth } from 'hooks'

const MainContent = ({ permission, admin, children }) => {
  const auth = useAuth()
  const redirectRoute = auth.checkMainRoute(auth.permissions)

  return (
    <Permitted
      tag={permission}
      admin={admin}
      fallback={redirectRoute ? <Redirect to={redirectRoute} /> : null}
    >
      {children}
    </Permitted>
  )
}

MainContent.propTypes = {
  children: PropTypes.node,
}

export default MainContent
